import { articleDetail } from '@/mocks/article';

export default function ArticleContent() {
  return (
    <article className="px-4 md:px-6 py-8 md:py-12">
      <div className="max-w-3xl mx-auto">
        <div className="prose-custom">
          {articleDetail.content.map((block, index) => {
            if (block.type === 'heading') {
              return (
                <h2
                  key={index}
                  className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mt-10 mb-4 first:mt-0"
                >
                  {block.text}
                </h2>
              );
            }
            return (
              <p
                key={index}
                className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5"
              >
                {block.text}
              </p>
            );
          })}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200">
          <div className="flex flex-wrap gap-3 items-center">
            <span className="text-sm text-foreground-500 font-medium">标签：</span>
            {articleDetail.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 bg-background-100 text-foreground-600 text-xs rounded-full whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 p-6 bg-accent-50/50 rounded-lg border border-accent-100">
          <p className="text-xs text-foreground-500 mb-2">
            <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
              <i className="ri-information-line"></i>
            </span>
            声明
          </p>
          <p className="text-xs text-foreground-500 leading-relaxed">
            本文内容来源于网络爆料及公开信息整理，吃瓜网站线路一不对内容的真实性作完全保证。如涉及侵权或不实内容，请通过网站底部联系方式与我们取得联系，我们将第一时间核实处理。
          </p>
        </div>
      </div>
    </article>
  );
}